"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeFormat = exports.defaultThreshold = exports.defaultKpi = void 0;
exports.defaultKpi = 'accuracy';
exports.defaultThreshold = 0.8;
exports.timeFormat = 'HH:mm';
//# sourceMappingURL=constants.js.map